'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _noop = require('../../utils/noop');

var _noop2 = _interopRequireDefault(_noop);

var _placeholderLA = require('./placeholderLA.svg');

var _placeholderLA2 = _interopRequireDefault(_placeholderLA);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageWithFallback = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(ImageWithFallback, _Component);

    function ImageWithFallback(props, context) {
        (0, _classCallCheck3.default)(this, ImageWithFallback);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ImageWithFallback.__proto__ || (0, _getPrototypeOf2.default)(ImageWithFallback)).call(this, props, context));

        _this.onClick = function (event) {
            _this.props.onClick(event);
        };

        _this.onError = function (event) {
            _this.setState({ imageSource: _placeholderLA2.default });
            _this.props.onError(event);
        };

        _this.onLoad = function (event) {
            _this.props.onLoad(event);

            if (_this.props.minSize) {
                var _this$imageRef$getBou = _this.imageRef.getBoundingClientRect(),
                    width = _this$imageRef$getBou.width;

                var _this$imageRef = _this.imageRef,
                    naturalHeight = _this$imageRef.naturalHeight,
                    naturalWidth = _this$imageRef.naturalWidth;


                _this.setState({
                    size: {
                        minHeight: width / naturalWidth * naturalHeight + 'px',
                        minWidth: width + 'px'
                    }
                });
            }
        };

        var url = props.src || _placeholderLA2.default;
        _this.state = {
            imageSource: props.forceFallback ? _placeholderLA2.default : url,
            size: {}
        };
        return _this;
    }

    (0, _createClass3.default)(ImageWithFallback, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            if (this.props.src !== nextProps.src) {
                // set the placeholder image first so that the previous image is cleared out before we set the new one.
                this.setState({ imageSource: _placeholderLA2.default });
                this.timeout = setTimeout(function () {
                    return _this2.setState({ imageSource: nextProps.src });
                }, 10);
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['alt', 'className', 'forceFallback', 'minSize', 'src', 'style']) || (0, _propsComparer2.default)(this.state, nextState, ['imageSource', 'size']);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.timeout) {
                clearTimeout(this.timeout);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                alt = _props.alt,
                className = _props.className,
                style = _props.style;
            var _state = this.state,
                imageSource = _state.imageSource,
                size = _state.size;


            var completeStyles = (0, _extends3.default)({}, style, size);
            var classes = [].concat((0, _toConsumableArray3.default)(className.split(' '))).join(' ').trim();
            return _react2.default.createElement('img', {
                alt: alt,
                ref: function ref(_ref) {
                    return _this3.imageRef = _ref;
                },
                className: classes,
                src: imageSource,
                onClick: this.onClick,
                onError: this.onError,
                onLoad: this.onLoad,
                style: completeStyles
            });
        }
    }]);
    return ImageWithFallback;
}(_react.Component), _class.defaultProps = {
    alt: '',
    className: '',
    forceFallback: false,
    onClick: _noop2.default,
    onError: _noop2.default,
    onLoad: _noop2.default,
    src: _placeholderLA2.default,
    style: {}
}, _temp);
exports.default = ImageWithFallback;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ImageWithFallback/ImageWithFallback.js
// module id = pjS5
// module chunks = 46